import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceStore {
    lookupService = new APIServiceLookUp();

    async getAllStore(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}store/getAllStore`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async setStore(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}store/setStore`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateStore(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}store/updateStore`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async delStore(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}store/delStore`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}